// test
import axios, { AxiosResponse } from 'axios';
import querystring from 'querystring';
import { AVLTypeEnum, IturanResponse } from 'src/screens/Main/components/Lines/hooks/useIturanData';
import { ILine, IClient, IDepartment, ILocation, IEditLine } from 'src/types/line';
import instance, { gpsServerUrl, myWayUrl, ITURAN_API_URL, myWayStudioServicesBaseUrl, getStoreProxyUrl } from './index';
import { makeApiCall } from './reportsApi/reportsApi';
import {
    IResponse,
    FcLogin,
    ILinesRequest,
    ILineRequest,
    IPassengerTypeResponse,
    IFcRequest,
    IFcResponseGetUserDetails,
    AxiosRes,
    IturanLocationRequestPayload,
    IEditLineRequest,
    FcLoginResponse,
} from './types';
import { createPayload, postLogin, postProxy } from './utilis';
// import { xmlParser } from '../screens/Main/components/LineMap/utils';

// FC REQUEST

export const validateToken = async (payload: { deviceToken: string }): Promise<{ data: object }> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin(
        `${myWayStudioServicesBaseUrl}/Login/LoginByToken`,
        data,
        payload.deviceToken
    );
};

// FC REQUEST

export const refreshToken = async (payload: { deviceToken: string }): Promise<{ data: object }> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin(
        `${myWayStudioServicesBaseUrl}/Login/RefreshToken`,
        data,
        payload.deviceToken
    );
};

// FC REQUEST

export const sendSMS = async (payload: {
    userMobile: string;
    deviceToken: string;
}): Promise<any> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin(
        `${myWayStudioServicesBaseUrl}/Login/SendSms`,
        data,
        payload.deviceToken
    );
};

// FC REQUEST

export const validateSms = async (payload: { verifyCode: string, deviceToken: string }): Promise<any> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin(
        `${myWayStudioServicesBaseUrl}/Login/LoginByOtpCheck`,
        data,
        payload.deviceToken
    );
};

// FC REQUEST

export const setLoginType = async (payload: {
    deviceToken: string;
    userUUID: string;
    autologin: number;
    userName?: string;
    userPass?: string;
    pinCode?: string;
}): Promise<FcLogin> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Update_Auto_Login_Type',
    });

    return postProxy<FcLogin>(
        `${myWayStudioServicesBaseUrl}/MyWayServerRequest`,
        data,
    ).then((result) => result.data);
};

// FC REQUEST

export const loginByPassword = (payload: {
    deviceToken: string;
    userName?: string;
    userPass?: string;
}): Promise<FcLogin> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin<FcLogin>(
        `${myWayStudioServicesBaseUrl}/Login/LoginByUserName`,
        data,
        payload.deviceToken
    ).then((result) => result.data);
};

// FC REQUEST

export const loginByPinCode = (payload: { deviceToken: string; pinCode: string }): Promise<FcLoginResponse> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin<FcLoginResponse>(
        `${myWayStudioServicesBaseUrl}/Login/LoginByPinCode`,
        data,
        payload.deviceToken
    ).then((result) => result.data);
};

// FC REQUEST

export const logout = (payload: { deviceToken?: string; userUUID: string }): Promise<FcLogin> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin<FcLogin>(
        `${myWayStudioServicesBaseUrl}/Login/Unregister`,
        data,
        payload.deviceToken
    ).then((result) => result.data);
};

export const privacyPolicyApproval = (payload: {
    deviceToken: string;
    versionNumber: string
    userMobile: string
})
    :
    Promise<{ data: any }> => {
    const data = querystring.stringify({
        ...createPayload(payload),
    });

    return postLogin(
        `${myWayStudioServicesBaseUrl}/Login/SetPrivacyPolicy`,
        data,
        payload.deviceToken
    );
}

export interface AVLCredentials {
    AVLUser: string; // account username on ituran
    AVLPass: string; // account password on ituran
}
export interface AVLData extends AVLCredentials {
    AVLType: AVLTypeEnum; // 0 - no gps system, 1 - ituran gps system
}
export interface GetActualDriverResponseData extends AVLData {
    accountCode: string;
    driverCode: string;
    response: string;
}

// FC REQUEST

export const getActualDriver = async (payload: {
    accountCode: string | number;
    lineCode: string | number;
}): Promise<AxiosResponse<GetActualDriverResponseData>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Actual_Driver',
    });

    return postProxy<GetActualDriverResponseData>(`${myWayStudioServicesBaseUrl}/MyWayServerRequest`, data);
};


// FC REQUEST

export const updateToken = ({
    dbUrl,
    indexerR = '',
    accessToken = '',
    tokenType = 'Bearer',
    ...payload
}: {
    proxyUrl?: string;
    dbUrl: string;
    token: string;
    contactUUID: string;
    indexerR?: string;
    accessToken?: string;
    tokenType?: string;
}): Promise<any> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Update_Token',
    });

    return postProxy(
        getStoreProxyUrl(),
        data,
        {
            indexerR,
            accessToken,
            tokenType,
        }
    );
};

// FC REQUEST
export const getUserDetails = async ({
    clinetProxy,
    dbUrl,
    ...payload
}: any): Promise<AxiosResponse<IFcResponseGetUserDetails>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_User_Details',
    });

    return postProxy<IFcResponseGetUserDetails>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const getLines = async ({
    clinetProxy,
    dbUrl,
    ...payload
}: ILinesRequest): Promise<AxiosResponse<IResponse<ILine>>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Lines',
    });

    return postProxy<IResponse<ILine>>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const getLineByCode = async ({
    dbUrl,
    ...payload
}: IEditLineRequest): Promise<AxiosResponse<IResponse<IEditLine>>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Line',
    });

    return postProxy<IResponse<IEditLine>>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const getOldLocation = async ({
    gps_server,
    ...payload
}: ILineRequest): Promise<AxiosResponse<IResponse<Array<ILocation>>>> => {
    const data = querystring.stringify({
        ...payload,
        webservice: 'ws_MyWayStudio_Get_CurrentPos',
    });

    return postProxy<IResponse<Array<ILocation>>>(`${myWayStudioServicesBaseUrl}/GpsServerRequest`, data);
};

// FC REQUEST

export const getLocation = async ({
    gps_server,
    ...payload
}: ILineRequest): Promise<AxiosResponse<ILocation>> => {
    const data = querystring.stringify({
        ...payload,
        webservice: 'ws_MyWayStudio_Get_GPSData',
    });

    return postProxy<ILocation>(`${myWayStudioServicesBaseUrl}/GpsServerRequest`, data);
};

// FC REQUEST

export const getIturanLocation: any = async ({
    ...payload
}: IturanLocationRequestPayload): Promise<AxiosResponse<IturanResponse['data']>> => {
    // return axios.post(ITURAN_API_URL, payload);
    const data = querystring.stringify({
        ...payload,
        webservice: 'GetFullReport_JSON',
    });
    return postProxy<IturanResponse['data']>(`${myWayStudioServicesBaseUrl}/IturanServerRequest`, data);
};

// FC REQUEST

export const getClients = async ({
    proxyUrl,
    dbUrl,
    token,
}: any): Promise<AxiosResponse<{ clients: IClient[]; response: string }>> => {
    const data = querystring.stringify({
        ...createPayload({ token }),
        webservice: 'ws_MyWayStudio_Get_Clients',
    });

    return postProxy<{ clients: IClient[]; response: string }>(getStoreProxyUrl(), data);
};

export interface GetDepartmentsArgs {
    proxyUrl: string | null | undefined;
    dbUrl: string;
    token: string;
    clientCode: string | number | null | undefined;
}

// FC REQUEST

export const getDepartments = async ({
    proxyUrl,
    dbUrl,
    token,
    clientCode,
}: GetDepartmentsArgs): Promise<AxiosResponse<{ departments: IDepartment[]; response: string }>> => {
    const data = querystring.stringify({
        ...createPayload({ token, clientCode }),
        webservice: 'ws_MyWayStudio_Get_Departments',
    });

    return postProxy<{ departments: IDepartment[]; response: string }>(getStoreProxyUrl(), data);
};

export const getVisasExcelReport = async ({
    dbUrl,
    clientCode,
    fromDate,
    toDate,
    token
}: {
    dbUrl: string;
    clientCode: string | number;
    fromDate: string;
    toDate: string;
    token: string;
}): Promise<
    AxiosResponse<{
        data: string | null;
        message: string;
        response: number | string;
    }>
> => {
    const data = querystring.stringify({
        ...createPayload({ clientCode, fromDate, toDate, token })
    });

    return postProxy<{ data: string | null; message: string; response: number | string }>(`${myWayStudioServicesBaseUrl}/GetExcelLinesReport`, data);
};

// FC REQUEST

export const getPassengerType = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: IFcRequest): Promise<AxiosResponse<IPassengerTypeResponse>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_PassTypes',
    });

    return postProxy<IPassengerTypeResponse>(getStoreProxyUrl(), data);
};

// export const getAccountShifts = (
//    requestConfig: GetAccountShiftsReqConfig,
// ): AxiosRes<any> => makeApiCall<BaseParams, any>(requestConfig);
